import App from '@/models/App'

export default class ShipLaborInternationalDateLineSkip extends App {
    static get entity() {
        return 'ShipLaborInternationalDateLineSkips'
    }
    static all() {
        return this.query().withAllRecursive().get()
    }

    static fields() {
        return {
            id: this.attr(''),
            shipId: this.attr(''),
            skipDate: this.attr(''),
            createdAt: this.attr(''),
        }
    }
    static apiConfig = {
        actions: {
            fetch(shipId) {
                return this.get(`${shipId}/labor/international/date/skip`, {
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            save(shipId, params) {
                return this.post(
                    `${shipId}/labor/international/date/skip`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(shipId, internationalDateId) {
                return this.delete(
                    `${shipId}/labor/international/date/${internationalDateId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: internationalDateId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
